import React, { memo, useState} from "react";
import {  useNavigate } from "react-router-dom";
import { BsPersonGear, BsClock  } from "react-icons/bs";
import { useAuth } from '../store/auth';
import ProfileSettingsModal from "./Profile/ProfileSettingsModal";
import SessionTimer from "./SessionTimer";
import SidebarNav from "./Sidebar/SidebarNav";
import { useToast } from "./Toast/ToastContext";
const Sidebar = memo(



  ({ user, isMobile, closeMobile, usersOpen, handleUsersClick, accessOpen, handleAccessClick,competitionOpen, handleCompetitionClick, isActive, logout }) => {

    const { showToast } = useToast();
      let logedUser = useAuth((state) => state.user);
   const [profileOpen, setProfileOpen] = useState(false);   


    const navItemClass = (active) =>
      `flex items-center gap-6 px-4 py-3 w-full rounded transition-colors ${
        active
          ? "bg-primary-700 text-white"
          : "text-white hover:bg-gray-700 hover:text-white"
      }`;



  //  useEffect(() => {
  //   const interval = setInterval(() => {
  //     setTimeLeft(prev => {
  //       if (prev <= 1) {
  //         handleLogout(); // automatyczny logout
  //         return 0;
  //       }
  //       return prev - 1;
  //     });
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, []);

  const handleChangePassword = async ({ oldPassword, newPassword, confirmPassword }) => {
  console.log("Stare:", oldPassword);
  console.log("Nowe:", newPassword);
  console.log("Powtórzone:", confirmPassword);

  try {
    const data = await fetch("https://hs2api.razamit.pl/change-password", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ oldPassword, newPassword, confirmPassword, userId: logedUser.userId }),
    });

    if (!data.ok) {
      const errorData = await data.json();
      showToast(errorData.message, "error");
      return;
    }
    showToast("Hasło zmienione pomyślnie", "success");
       

   // handleLogout();
    setProfileOpen(false); // zamykamy modal
  } catch (err) {
    alert(err.message);
  }
};
      const navigate = useNavigate();
const handleLogout = async () =>{
console.log("logout");
  //const logout = useAuth((state) => state.logout);

   // useAuth.set({ isLoggingOut: true }); // ustaw od razu
   // await logout(() => navigate('/login')); // callback po logout

 await logout();
 navigate('/', { replace: true });
};
    return (
      <div className="h-full flex flex-col bg-gray-900">
        {/* 🏷️ Logo */}
    <div className="">
     <div className="relative p-6 bg-[radial-gradient(circle_at_30%_20%,rgba(99,102,241,0.05),transparent_50%),radial-gradient(circle_at_70%_80%,rgba(59,130,246,0.05),transparent_50%)] shadow-xl overflow-hidden">
  <div className="absolute inset-0 opacity-10"></div>

 <div className="relative z-10 flex flex-col items-center px-4 py-5 text-center">
  <div className="relative group">
    <img
      className="h-14 w-auto transition-all duration-300 group-hover:scale-105 drop-shadow-xl"
      src="https://hs2api.razamit.pl/logo.png"
      alt="Logo"
    />

    <div className="absolute inset-0 -z-10 rounded-full bg-white/10 blur-xl opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
  </div>

  <div className="mt-4">
    <h2 className="text-sm font-semibold tracking-wide text-white">
      License Manager
    </h2>

    <p className="mt-1 max-w-[180px] text-xs leading-relaxed text-white/60">
      Zarządzanie licencjami
      <br />
      oraz rozliczeniami systemu
    </p>
  </div>

  <div className="mt-4 h-px w-32 bg-white/10" />
</div>
</div>
</div>


        {/* 🧭 Nawigacja */}
     <SidebarNav
  isActive={isActive}
  usersOpen={usersOpen}
  handleUsersClick={handleUsersClick}
  accessOpen={accessOpen}
  handleAccessClick={handleAccessClick}
  logedUser={logedUser}
  isMobile={isMobile}
  closeMobile={closeMobile}
  competitionOpen={competitionOpen}
  handleCompetitionClick={handleCompetitionClick}
/>
        {/* 👤 Profil użytkownika */}
        <div className="px-4 pb-4 pt-4 border-t border-gray-700">
          <div className="flex items-center justify-between rounded-2xl border border-white/10 bg-white/5 p-3 backdrop-blur-sm">
  <div className="flex items-center gap-3">
    <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-primary-500 to-primary-700 text-base font-bold text-white shadow-lg">
      {user?.name?.[0]?.toUpperCase() || "U"}
    </div>

    <div className="min-w-0">
      <p className="truncate text-sm font-semibold text-white">
        {user?.name || "Użytkownik"}
      </p>

      <p className="truncate text-xs text-white/60">
        {user?.login || "brak loginu"}
      </p>

      <span className="mt-1 inline-flex rounded-full bg-primary-500/20 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide text-primary-200">
        {user?.role || "Brak roli"}
      </span>
    </div>
  </div>

  <button
    onClick={() => setProfileOpen(true)}
    className="flex h-10 w-10 items-center justify-center rounded-xl text-white/70 transition-all duration-200 hover:bg-white/10 hover:text-white"
    title="Ustawienia profilu"
  >
    <BsPersonGear className="h-5 w-5" />
  </button>
</div>
        </div>
         <div className="px-4 py-4 border-t border-gray-700 text-xs text-white flex items-center">
                        {/* <span className="text-xs">Za </span> */}

{/* <span className="text-sm">&nbsp;{formatTime(timeLeft)}&nbsp;</span>

        <span>  min koniec sesji</span> */}
 <div className="flex items-center gap-2 rounded-xl bg-white/10 px-3 py-2 text-xs text-white/70 shadow-sm">
  <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-white/10 text-white">
    <BsClock className="h-4 w-4" />
  </span>

  <div className="flex items-center gap-1">
    <span className="text-white/60">
      Sesja:
    </span>

    <span className="font-semibold text-white">
      <SessionTimer onTimeout={handleLogout} />
    </span>

    <span className="text-white/60">
      min
    </span>
  </div>
</div>
      </div>
     
         <ProfileSettingsModal
        open={profileOpen}
        user={user}
        onClose={() => setProfileOpen(false)}
        onChangePassword={handleChangePassword}
        logout={handleLogout}
      />

      
      </div>
    );
  }
);

export default Sidebar;
